import { render, staticRenderFns } from "./price_extend.vue?vue&type=template&id=52f5f1c0&"
import script from "./price_extend.vue?vue&type=script&lang=ts&"
export * from "./price_extend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports